import React from "react";

import "./DialogPopupToggleOptions.css";

function DialogPopupToggleOptions({
  toggleOptions,
  regenerateDialogContent,
  toggleRegenerateOptions,
  onChangeToggleState,
  checkOptions,
}) {
  return (
    <div className="dialog-popup-toggle-options-section">
      <label className="dialog-popup-toggle-options-section-label">
        <span className="dialog-popup-toggle-options-section-title">Quick Options</span>
        <span className="dialog-popup-toggle-options-section-description">Select common improvements to apply</span>
      </label>
      <div className="dialog-popup-toggle-options-options">
        {toggleOptions.map((toggleOption) => {
          const isSelected = regenerateDialogContent.options.includes(toggleOption.states[toggleOption.currentState]);

          return (
            <div key={toggleOption.id} className="dialog-popup-toggle-options-toggle-option">
              <label className="dialog-popup-toggle-options-toggle-option-header">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => toggleRegenerateOptions(toggleOption.states[toggleOption.currentState])}
                  className="dialog-popup-toggle-options-checkbox"
                />
                <span className="dialog-popup-toggle-options-option-text">{toggleOption.label}</span>
                <div className="dialog-popup-toggle-options-toggle-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="5" width="22" height="14" rx="7" ry="7" stroke="currentColor" strokeWidth="2" />
                    <circle cx={toggleOption.currentState === 0 ? "8" : "16"} cy="12" r="3" fill="currentColor" />
                  </svg>
                </div>
              </label>

              {isSelected && (
                <div className="dialog-popup-toggle-options-toggle-controls">
                  <button
                    type="button"
                    onClick={() => onChangeToggleState(toggleOption, 0)}
                    className={`dialog-popup-toggle-options-toggle-state ${
                      toggleOption.currentState === 0 ? "active" : ""
                    }`}
                  >
                    {toggleOption.states[0]}
                  </button>
                  <div className="dialog-popup-toggle-options-toggle-switch">
                    <button
                      type="button"
                      onClick={() => onChangeToggleState(toggleOption, toggleOption.currentState === 0 ? 1 : 0)}
                      className={`dialog-popup-toggle-options-toggle-switch-button ${
                        toggleOption.currentState === 1 ? "active" : ""
                      }`}
                    >
                      <div className="dialog-popup-toggle-options-toggle-switch-slider"></div>
                    </button>
                  </div>
                  <button
                    type="button"
                    onClick={() => onChangeToggleState(toggleOption, 1)}
                    className={`dialog-popup-toggle-options-toggle-state ${
                      toggleOption.currentState === 1 ? "active" : ""
                    }`}
                  >
                    {toggleOption.states[1]}
                  </button>
                </div>
              )}
            </div>
          );
        })}
        {checkOptions.map((option) => (
          <div key={option.name} className="dialog-popup-toggle-options-toggle-option">
            <label className="dialog-popup-toggle-options-toggle-option-header">
              <input
                type="checkbox"
                checked={regenerateDialogContent.options.includes(option.name)}
                onChange={() => toggleRegenerateOptions(option.name)}
                className="dialog-popup-toggle-options-checkbox"
              />
              <span className="dialog-popup-toggle-options-option-text">{option.name}</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DialogPopupToggleOptions;
